module.exports = __webpack_public_path__ + "static/media/PaymentCouponScreen.13a3376f.png";